module.exports = __webpack_public_path__ + "static/media/pic14.13d5936c.jpeg";